var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Tile } from '../../common/Tile';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { thousandSeparator } from '../../../utils/utils';
import { TileHeader } from '../../common/TileHeader';
import { AlertDialog } from '../../common/alert-dialog';
import { CreateOptionGrantModal, } from './create-option-grant-modal';
import { OptionGrantListItem, } from './option-grant-list-item';
export function OptionPlanTile(props) {
    // State
    var _a = React.useState(false), deleteDialogIsOpen = _a[0], setDeleteDialogIsOpen = _a[1];
    var _b = React.useState(false), deleteAlertIsOpen = _b[0], setAlertDialogIsOpen = _b[1];
    var _c = React.useState(false), createOptionGrantModalIsOpen = _c[0], setCreateOptionGrantModalIsOpen = _c[1];
    // Event handlers
    var openDeleteDialog = function () { return setDeleteDialogIsOpen(true); };
    var closeDeleteDialog = function () { return setDeleteDialogIsOpen(false); };
    var openDeleteAlert = function () { return setAlertDialogIsOpen(true); };
    var closeDeleteAlert = function () { return setAlertDialogIsOpen(false); };
    var confirmDelete = function () {
        props.onDeleteConfirm();
        closeDeleteDialog();
    };
    var openCreateDialog = function () { return setCreateOptionGrantModalIsOpen(true); };
    var closeCreateDialog = function () { return setCreateOptionGrantModalIsOpen(false); };
    // Helper
    var availableQuantity = props.planSize - props.issuedOptions - props.draftedOptions;
    return (_jsxs(Tile, { children: [_jsx(AlertDialog, { isOpen: deleteDialogIsOpen, title: "Delete this option plan?", content: "This action cannot be undone", onBackdropClick: closeDeleteDialog, buttons: [
                    {
                        label: 'Delete',
                        primary: true,
                        onClick: confirmDelete,
                    },
                    {
                        label: 'Cancel',
                        onClick: closeDeleteDialog,
                    },
                ] }, void 0),
            _jsx(AlertDialog, { isOpen: deleteAlertIsOpen, title: "Plan may not be deleted", content: "Option plans with option grants may not be deleted.", onBackdropClick: closeDeleteAlert, buttons: [
                    {
                        label: 'Close',
                        primary: true,
                        onClick: closeDeleteAlert,
                    },
                ] }, void 0),
            _jsx(CreateOptionGrantModal, { optionPlanName: props.name, availableQuantity: availableQuantity, planExercisePrice: props.exercisePrice, planPurchasePrice: props.purchasePrice, open: createOptionGrantModalIsOpen, onCancel: closeCreateDialog, onConfirm: function (e) {
                    props.onAddClick(e);
                    closeCreateDialog();
                } }, void 0),
            _jsx(TileHeader, __assign({ actions: [
                    { icon: 'edit', onClick: props.onEditClick },
                    {
                        icon: 'delete',
                        onClick: props.optionGrants.length
                            ? openDeleteAlert
                            : openDeleteDialog,
                    },
                ] }, { children: props.name }), void 0),
            _jsxs(List, { children: [_jsx(ListItem, { primary: "Issued options", label: thousandSeparator(props.issuedOptions) + " / " + thousandSeparator(props.planSize) }, void 0),
                    _jsx(ListItem, { primary: "Remaining pool", label: thousandSeparator(props.planSize - props.issuedOptions) }, void 0),
                    _jsx(ListItem, { primary: "Share class", label: thousandSeparator(props.shareClassName) }, void 0),
                    _jsx(ListItem, { primary: "Purchase price", secondary: "per option grant", label: thousandSeparator(props.purchasePrice) }, void 0),
                    _jsx(ListItem, { primary: "Exercise price", secondary: "per share", label: thousandSeparator(props.exercisePrice) }, void 0)] }, void 0),
            _jsx(TileHeader, __assign({ actions: [{ icon: 'add', onClick: openCreateDialog }] }, { children: "Grants" }), void 0),
            _jsx(List, { children: props.optionGrants.map(function (optionGrant) { return (_jsx(OptionGrantListItem, { id: optionGrant.id, holder: optionGrant.holder, quantity: optionGrant.quantity, state: optionGrant.state, onClick: optionGrant.onClick }, optionGrant.id)); }) }, void 0)] }, void 0));
}
//# sourceMappingURL=option-plan-tile.js.map